import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { PanelBarExpandMode } from '@progress/kendo-angular-layout';
import { IMasterData, IThermalCalculateData, IThermalCalculator, IThermalCalculatorLabel, MasterData } from '../../../core/models';
import { LanguageTranslationService } from '../../../core/services/language-translation.service';
import { SelfUtilityService } from '../../../core/services/self-utility.service';
import { UserService } from '../../../core/services/user.service';
import { formatDate } from '@angular/common';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { style } from '@angular/animations';
@Component({
  selector: 'app-thermal-calculator',
  templateUrl: './thermal-calculator.component.html',
  styleUrls: ['./thermal-calculator.component.scss']
})
export class ThermalCalculatorComponent implements OnInit {
  //#region member and variable declaration
  thermalCalculatorTxt: IThermalCalculatorLabel;
  @ViewChild('panelbar', { static: false }) panel;
  public expandMode: number = PanelBarExpandMode.Multiple;
  public kendoPanelBarExpandMode: any = PanelBarExpandMode;

  public productTypeData: any = [];
  public productTypeFilteredData: any = [];
  public productSeriesData: any = [];
  public productSeriesFilteredData: any = [];
  public ufactorData: any = [];
  public ufactorFilteredData: any = [];
  public SolarHeatData: any = [];
  public SolarHeatFilteredData: any = [];
  public visibleTransmittanceData: any = [];
  public visibleTransmittanceFilteredData: any = [];
  public totalOfHorizontalData: any = [];
  public totalOfVerticalData: any = [];
  public list: any = [];

  public saveInProcess: boolean;
  public thermalCalculatorForm: FormGroup;
  public showCalculationEntries: boolean = true;
  public showCalculationTable: boolean = false;
  public isProjectSizeVisionSelected: boolean;
  public isProjectSizeDimensionSelected: boolean;
  public hasProjectSizeDimensionImage: boolean = true;
  public downloadInProgress: boolean;
  public thermalCalculatorResource: any = {};
  //#endregion
  constructor(private formBuilder: FormBuilder,
    private selfService: SelfUtilityService, private languageTranslationService: LanguageTranslationService) { }

  ngOnInit() {
    this.loadLanguageTranslationData();
    this.intializeForm();
    this.loadDropdownData();
  }
  //#region page load method calls and dropdown change
  intializeForm() {
    this.thermalCalculatorForm = this.formBuilder.group({
      projectName: new FormControl(),
      projectLocation: new FormControl(),
      productType: new FormControl(),
      productSeries: new FormControl(),
      ufactor: new FormControl(),
      solarHeat: new FormControl(),
      visibleTransmittance: new FormControl(),
      sizeCategory: new FormControl(),
      visibleArea: new FormControl(),
      totalOfVertical: new FormControl(),
      totalOfHorizontal: new FormControl(),
    });
  }
  get f() {
    return this.thermalCalculatorForm.controls;
  }
  loadDropdownData() {
    this.selfService.thermalCalculatorPayload().subscribe((response) => {

      if (response) {
        console.log(response)
        this.productTypeData = response.thermalProductType;
        this.productTypeFilteredData = response.thermalProductType;
        this.ufactorData = response.thermalUFactor;
        //this.ufactorFilteredData = response.thermalUFactor;
        this.SolarHeatData = response.thermalSolarHeatGainCoefficient;
        //this.SolarHeatFilteredData = response.thermalSolarHeatGainCoefficient;
        this.visibleTransmittanceData = response.thermalVisibleTransmittance;
        //this.visibleTransmittanceFilteredData = response.thermalVisibleTransmittance;
      }
    })
  }
  //#region dropdown filter
  handleProductTypeFilter(event) {
    if (!event) {
      this.productTypeData = this.productTypeFilteredData;
      return;
    }
    const filterArray = this.productTypeFilteredData.filter(x => x.productType != null);
    this.productTypeData = filterArray.filter(
      (s) => s.productType.toLowerCase().indexOf(event.toLowerCase()) !== -1
    );
  }
  handleProductSeriesFilter(event) {
    if (!event) {
      this.productSeriesData = this.productSeriesFilteredData;
      return;
    }
    const filterArray = this.productSeriesFilteredData.filter(x => x.productSeries != null);
    this.productSeriesData = filterArray.filter(
      (s) => s.productSeries.toLowerCase().indexOf(event.toLowerCase()) !== -1
    );
  }
  //handleUFactorFilter(event) {
  //  if (!event) {
  //    this.ufactorData = this.ufactorFilteredData;
  //    return;
  //  }
  //  const input = parseInt(event);
  //  this.ufactorData = this.ufactorFilteredData.filter(
  //    (s) => s.uFactor.indexOf(input) !== -1
  //  );
  //}
  //handleSolarHeatFilter(event) {
  //  if (!event) {
  //    this.SolarHeatData = this.SolarHeatFilteredData;
  //    return;
  //  }
  //  const filterArray = this.SolarHeatFilteredData.filter(x => x.solarHeatGainCoefficient != null);
  //  this.SolarHeatData = filterArray.filter(
  //    (s) => s.solarHeatGainCoefficient.toLowerCase().indexOf(event.toLowerCase()) !== -1
  //  );
  //}
  //#endregion
  productTypeChange(event) {
    this.selfService.getProjectSeries(event.productType).subscribe(response => {
      if (response) {
        this.productSeriesData = response;
        this.productSeriesFilteredData = response;
      }
    })
    this.f.sizeCategory.setValue(null);
    this.toggle(null);
    this.toggle(null);
    this.totalOfVerticalData = [];
    this.totalOfHorizontalData = [];
    this.isProjectSizeDimensionSelected = false;
    this.isProjectSizeVisionSelected = false;
  }
  //#endregion

  //#region language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "selectionsPanelLbl" },
      { controlName: "systemSelectionLbl" },
      { controlName: "projectNameLbl" },
      { controlName: "projectLocationLbl" },
      { controlName: "productTypeLbl" },
      { controlName: "productSeriesLbl" },
      { controlName: "customerGlazingInfoLbl" },
      { controlName: "ufactorLbl" },
      { controlName: "solarHeatLbl" },
      { controlName: "visibleTransmittanceLbl" },
      { controlName: "testSizeLbl" },
      { controlName: "projectSizeVisionLbl" },
      { controlName: "projectSizeDimensionLbl" },
      { controlName: "visibleAreaLbl" },
      { controlName: "jobSpecificationLbl" },
      { controlName: "jobSpecificationMsg" },
      { controlName: "totalOfHorizontalLbl" },
      { controlName: "totalOfVerticalLbl" },
      { controlName: "continueLbl" },
      { controlName: "termsConditionTitleLbl" },
      { controlName: "termsConditionContentLbl" },
      { controlName: "acceptTermsConditionLbl" },
      { controlName: "calculateLbl" },
      { controlName: "cancelLbl" },
      { controlName: "coglbl" },
      { controlName: "ngrcLbl" },
      { controlName: "projectValueLbl" },
      { controlName: "shgcLbl" },
      { controlName: "vtLbl" },
      { controlName: "visionAreaLbl" },
      { controlName: "tableContent1Lbl" },
      { controlName: "tableContent2Lbl" },
      { controlName: "tableContent3Lbl" },
      { controlName: "tableContent4Lbl" },
      { controlName: "tableContent5Lbl" },
      { controlName: "editLbl" },
      { controlName: "downloadLbl" },

    ];
    const componentName = "thermalCalculator";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.thermalCalculatorTxt = response[response.length - 1];
    }

    console.log(response);
  }
  //#endregion
  //#region variable/label declaration
  protected thermalCalculator = {
    selectionsPanelLbl: 'SELECTION',
    systemSelectionLbl: 'System Selection',
    projectNameLbl: 'Project Name',
    projectLocationLbl: 'Project Location',
    productTypeLbl: 'Project Type',
    productSeriesLbl: 'Project Series',
    customerGlazingInfoLbl: 'Customer Provided Glazing Information',
    ufactorLbl: 'U-Factor',
    solarHeatLbl: 'Solar Heat Gain Coefficient',
    visibleTransmittanceLbl: 'Visible Transmittance',
    testSizeLbl: 'TEST SIZE ONLY',
    projectSizeVisionLbl: 'PROJECT SIZES (VISION AREA % )',
    projectSizeDimensionLbl: 'PROJECT SIZES (DETAIL DIMENSIONS)',
    visibleAreaLbl: 'Vision Area %',
    jobSpecificationLbl: 'Your Job Specifications',
    jobSpecificationMsg: `Curtain wall Project Sizes (Detail Dimensions) is based on a single bay width that is representative of the curtain wall elevation.
Select the number of vertical and horizontal DLOS when applicable.Specify DLO as vision or spandrel when applicable.Enter dimensions in feet & inches.
(This calculation is based on a single bay of your product type for: CW, WW, UW.Only applies too horizontals and verticals that runs all the way thru the system.)`,
    totalOfHorizontalLbl: 'Total # of Horizontals',
    totalOfVerticalLbl: 'Total # of Verticals',
    continueLbl: 'Continue',
    termsConditionTitleLbl: 'Thermal Calculator Terms and Conditions',
    termsConditionContentLbl: 'In submitting this request you represent and warrant that you are authorized by your company to make this request, and that the report being sought is to be provided for a lawful purpose. In consideration for Kawneer accommodating your request you understand and agree that any and all information released is being provided without any representation or warranty, express or implied, as to the accuracy or completeness of the information provided, or its suitability for whatever your intended use or the use of any other third-party, on the part of Kawneer or its parent company or any of their respective affiliates or representatives or employees. Moreover, you agree that Kawneer, its parent company, and any of their respective affiliates or representatives or employees shall have no liability, under law or contract, for any loss or injury caused by their neglect or other act or failure to act on their part in working, collecting, or communicating this information. Laws and building and safety codes governing the design and use of glazed entrance, window, and curtain wall products vary widely. Kawneer does not control the selection of product configurations, operating hardware, or glazing materials, and assumes no responsibility therefor.',
    acceptTermsConditionLbl: 'I Accept Terms & Conditions',
    calculateLbl: 'Calculate',
    cancelLbl: 'Cancel',
    coglbl: 'COG',
    ngrcLbl: 'NFRC Size Values',
    projectValueLbl: 'Project Values',
    shgcLbl: 'SHGC',
    vtLbl: 'VT',
    visionAreaLbl: 'Vision Area %',
    tableContent1Lbl: '*Spandrel area and associated frame excluded from the percentage of vision area calculation',
    tableContent2Lbl: 'Kawneer Test Report NFRC 102#',
    tableContent3Lbl: 'Kawneer Test Report AMMA 507#',
    tableContent4Lbl: 'NFRC 100/200/500 Kawneer Test Report #',
    tableContent5Lbl: 'Kawneer Certificate of Compliance#',
    editLbl: 'Edit',
    downloadLbl: 'Download',
    testTypeSelected: false,
    projectSizeVisionSelected: false,
    projectSizeDimensionSelected: false,
    isEmptyProjectName: false,
    isEmptyProjectLocation: false,
    isEmptyProductType: false,
    isEmptyProductSeries: false,
    isEmptyUfactor: false,
    isEmptySolarHeat: false,
    isEmptyVisibleTransmittance: false,
    isSubmitted: false,
    isSelectionPanelValid: false,
  }
  //#endregion
  //#region radio button toggle

  toggle(selectedType) {
    this.f.visibleArea.setValue(0);
    this.thermalCalculatorResource.ProjectSizeDimensionImage = null;
    this.thermalCalculatorResource.productType = null;
    const defaultOption = { name: "Choose...", value: 0 };
    if (selectedType == 'testType') {
      this.isProjectSizeVisionSelected = false;
      this.isProjectSizeDimensionSelected = false;
    } else if (selectedType == 'projectSizeVision') {
      this.isProjectSizeVisionSelected = true;
      this.isProjectSizeDimensionSelected = false;
    } else if (selectedType == 'projectSizeDimension') {
      this.isProjectSizeVisionSelected = false;
      this.isProjectSizeDimensionSelected = true;
      this.hasProjectSizeDimensionImage = true;
      this.thermalCalculatorResource.productType = this.f.productType.value;
      this.totalOfVerticalData = [];
      this.totalOfHorizontalData = [];
      this.thermalCalculatorResource.horizontalDloTextHide = false;
      this.thermalCalculatorResource.verticalDloTextHide = false;
      if (this.thermalCalculatorResource.productType === "Window Wall" || this.thermalCalculatorResource.productType === "StoreFront Framing") {
        this.thermalCalculatorResource.ProjectSizeDimensionImage = "../../assets/images/ThermalCalculator/ConfigSF.PNG";
        this.totalOfVerticalData.push(defaultOption);
        this.totalOfHorizontalData.push(defaultOption);
        for (let i = 2; i <= 20; i++) {
          this.totalOfVerticalData.push({ name: i, value: i });
          this.totalOfHorizontalData.push({ name: i, value: i });
        }
        this.f.totalOfVertical.setValue(2);
        this.f.totalOfHorizontal.setValue(2);
      } else if (this.thermalCalculatorResource.productType === "Curtain Wall" || this.thermalCalculatorResource.productType === "Unitized Wall") {
        this.thermalCalculatorResource.ProjectSizeDimensionImage = "../../assets/images/ThermalCalculator/ConfigCW.PNG";
        this.totalOfHorizontalData.push(defaultOption);
        for (let i = 2; i <= 20; i++) {
          this.totalOfHorizontalData.push({ name: i, value: i });
        }
        this.f.totalOfHorizontal.setValue(2);
      } else if (this.thermalCalculatorResource.productType === "Door" || this.thermalCalculatorResource.productType === "Window") {
        this.hasProjectSizeDimensionImage = false;
        this.thermalCalculatorResource.horizontalDlo = [];
        this.thermalCalculatorResource.verticalDlo = [];
        this.thermalCalculatorResource.horizontalDloTextHide = true;
        this.thermalCalculatorResource.verticalDloTextHide = true;
        this.thermalCalculatorResource.horizontalDlo.push({ name: "Width", feet: 0, inch: 0 });
        this.thermalCalculatorResource.verticalDlo.push({ name: "Height", feet: 0, inch: 0 });
      }
    }
    this.horizontalSelectionChange({});
    this.verticalSelectionChange({});
  }
  //#endregion
  horizontalSelectionChange(event) {
    this.thermalCalculatorResource.totalOfVertical = +this.f.totalOfVertical.value;
    this.thermalCalculatorResource.totalOfHorizontal = +this.f.totalOfHorizontal.value;

    if (this.thermalCalculatorResource.productType === "Window Wall") {
      this.thermalCalculatorResource.horizontalDlo = [];
      if (this.thermalCalculatorResource.totalOfHorizontal > 3) {
        this.thermalCalculatorResource.horizontalDlo.push({ name: "Left", feet: 0, inch: 0 });
        for (let i = 1; i <= this.thermalCalculatorResource.totalOfHorizontal - 3; i++) {
          const tempName = `Center${i}`;
          this.thermalCalculatorResource.horizontalDlo.push({ name: tempName, feet: 0, inch: 0 });
        }
        this.thermalCalculatorResource.horizontalDlo.push({ name: "Right", feet: 0, inch: 0 });
      } else if (this.thermalCalculatorResource.totalOfHorizontal === 3) {
        this.thermalCalculatorResource.horizontalDlo.push({ name: "Left", feet: 0, inch: 0 });
        this.thermalCalculatorResource.horizontalDlo.push({ name: "Right", feet: 0, inch: 0 });
      } else if (this.thermalCalculatorResource.totalOfHorizontal === 2) {
        this.thermalCalculatorResource.horizontalDlo.push({ name: "", feet: 0, inch: 0 });
      }
      return;
    } else if (this.thermalCalculatorResource.productType === "Curtain Wall" || this.thermalCalculatorResource.productType === "Unitized Wall") {
      this.thermalCalculatorResource.horizontalDlo = [];
      this.thermalCalculatorResource.verticalDlo = [];
      this.thermalCalculatorResource.horizontalDlo.push({ name: "", feet: 0, inch: 0 });
      const ddlOptions = ["Vision", "Spandrel"]
      if (this.thermalCalculatorResource.totalOfHorizontal > 3) {
        this.thermalCalculatorResource.verticalDlo.push({ name: "Top", feet: 0, inch: 0, type: "Vision", typeOptions: ddlOptions });
        for (let i = 1; i <= this.thermalCalculatorResource.totalOfHorizontal - 3; i++) {
          const tempName = `Center${i}`;
          this.thermalCalculatorResource.verticalDlo.push({ name: tempName, feet: 0, inch: 0, type: "Vision", typeOptions: ddlOptions });
        }
        this.thermalCalculatorResource.verticalDlo.push({ name: "Bottom", feet: 0, inch: 0, type: "Vision", typeOptions: ddlOptions });
      } else if (this.thermalCalculatorResource.totalOfHorizontal === 3) {
        this.thermalCalculatorResource.verticalDlo.push({ name: "Top", feet: 0, inch: 0, type: "Vision", typeOptions: ddlOptions });
        this.thermalCalculatorResource.verticalDlo.push({ name: "Bottom", feet: 0, inch: 0, type: "Vision", typeOptions: ddlOptions });
      } else if (this.thermalCalculatorResource.totalOfHorizontal === 2) {
        this.thermalCalculatorResource.verticalDlo.push({ name: "", feet: 0, inch: 0, type: "Vision", typeOptions: ddlOptions });
      }
      return;
    } else if (this.thermalCalculatorResource.productType === "StoreFront Framing") {
      this.thermalCalculatorResource.verticalDlo = [];
      if (this.thermalCalculatorResource.totalOfHorizontal > 3) {
        this.thermalCalculatorResource.verticalDlo.push({ name: "Top", feet: 0, inch: 0 });
        for (let i = 1; i <= this.thermalCalculatorResource.totalOfHorizontal - 3; i++) {
          const tempName = `Center${i}`;
          this.thermalCalculatorResource.verticalDlo.push({ name: tempName, feet: 0, inch: 0 });
        }
        this.thermalCalculatorResource.verticalDlo.push({ name: "Bottom", feet: 0, inch: 0 });
      } else if (this.thermalCalculatorResource.totalOfHorizontal === 3) {
        this.thermalCalculatorResource.verticalDlo.push({ name: "Top", feet: 0, inch: 0 });
        this.thermalCalculatorResource.verticalDlo.push({ name: "Bottom", feet: 0, inch: 0 });
      } else if (this.thermalCalculatorResource.totalOfHorizontal === 2) {
        this.thermalCalculatorResource.verticalDlo.push({ name: "", feet: 0, inch: 0 });
      }
      return;
    }

  }
  verticalSelectionChange(event) {
    this.thermalCalculatorResource.totalOfVertical = +this.f.totalOfVertical.value;
    this.thermalCalculatorResource.totalOfHorizontal = +this.f.totalOfHorizontal.value;
    if (this.thermalCalculatorResource.productType === "Window Wall") {
      this.thermalCalculatorResource.verticalDlo = [];
      if (this.thermalCalculatorResource.totalOfVertical > 3) {
        this.thermalCalculatorResource.verticalDlo.push({ name: "Top", feet: 0, inch: 0 });
        for (let i = 1; i <= this.thermalCalculatorResource.totalOfVertical - 3; i++) {
          const tempName = `Center${i}`;
          this.thermalCalculatorResource.verticalDlo.push({ name: tempName, feet: 0, inch: 0 });
        }
        this.thermalCalculatorResource.verticalDlo.push({ name: "Bottom", feet: 0, inch: 0 });
      } else if (this.thermalCalculatorResource.totalOfVertical === 3) {
        this.thermalCalculatorResource.verticalDlo.push({ name: "Top", feet: 0, inch: 0 });
        this.thermalCalculatorResource.verticalDlo.push({ name: "Bottom", feet: 0, inch: 0 });
      } else if (this.thermalCalculatorResource.totalOfVertical === 2) {
        this.thermalCalculatorResource.verticalDlo.push({ name: "", feet: 0, inch: 0 });
      }
      return;
    } else if (this.thermalCalculatorResource.productType === "StoreFront Framing") {
      this.thermalCalculatorResource.horizontalDlo = [];
      if (this.thermalCalculatorResource.totalOfVertical > 3) {
        this.thermalCalculatorResource.horizontalDlo.push({ name: "Left", feet: 0, inch: 0 });
        for (let i = 1; i <= this.thermalCalculatorResource.totalOfVertical - 3; i++) {
          const tempName = `Center${i}`;
          this.thermalCalculatorResource.horizontalDlo.push({ name: tempName, feet: 0, inch: 0 });
        }
        this.thermalCalculatorResource.horizontalDlo.push({ name: "Right", feet: 0, inch: 0 });
      } else if (this.thermalCalculatorResource.totalOfVertical === 3) {
        this.thermalCalculatorResource.horizontalDlo.push({ name: "Left", feet: 0, inch: 0 });
        this.thermalCalculatorResource.horizontalDlo.push({ name: "Right", feet: 0, inch: 0 });
      } else if (this.thermalCalculatorResource.totalOfVertical === 2) {
        this.thermalCalculatorResource.horizontalDlo.push({ name: "", feet: 0, inch: 0 });
      }
      return;
    }

  }
  //#region validation and reset
  protected resetThermalCalculatorForm() {
    this.thermalCalculatorForm.reset();
    this.thermalCalculator.isEmptyProjectName = false;
    this.thermalCalculator.isEmptyProjectLocation = false;
    this.thermalCalculator.isEmptyProductType = false;
    this.thermalCalculator.isEmptyProductSeries = false;
    this.thermalCalculator.isEmptyUfactor = false;
    this.thermalCalculator.isEmptySolarHeat = false;
    this.thermalCalculator.isEmptyVisibleTransmittance = false;
    this.thermalCalculator.isSubmitted = false;
    this.thermalCalculator.isSelectionPanelValid = false;
  }
  protected validateThermalCalculatorForm(): boolean {
    let isValid = true;
    const controls = this.thermalCalculatorForm.controls;
    if (this.thermalCalculator.isSubmitted) {
      if (controls.projectName.value) {
        this.thermalCalculator.isEmptyProjectName = false;
      } else {
        this.thermalCalculator.isEmptyProjectName = true;
        isValid = false;
      }
      if (controls.projectLocation.value) {
        this.thermalCalculator.isEmptyProjectLocation = false;
      } else {
        this.thermalCalculator.isEmptyProjectLocation = true;
        isValid = false;
      }
      const productType = controls.productType.value ? controls.productType.value : "";
      if (productType) {
        this.thermalCalculator.isEmptyProductType = false;
      } else {
        this.thermalCalculator.isEmptyProductType = true;
        isValid = false;
      }
      const p = controls.productSeries.value ? controls.productSeries.value.productSeries : "";
      if (p) {
        this.thermalCalculator.isEmptyProductSeries = false;
      } else {
        this.thermalCalculator.isEmptyProductSeries = true;
        isValid = false;
      }
      const q = controls.ufactor.value ? controls.ufactor.value.uFactor : "";
      if (q > -1) {
        this.thermalCalculator.isEmptyUfactor = false;
      } else {
        this.thermalCalculator.isEmptyUfactor = true;
        isValid = false;
      }
      const r = controls.solarHeat.value ? controls.solarHeat.value.solarHeatGainCoefficient : "";
      if (r > -1) {
        this.thermalCalculator.isEmptySolarHeat = false;
      } else {
        this.thermalCalculator.isEmptySolarHeat = true;
        isValid = false;
      }
      const s = controls.visibleTransmittance.value ? controls.visibleTransmittance.value.visibleTransmittance : "";
      if (s > -1) {
        this.thermalCalculator.isEmptyVisibleTransmittance = false;
      } else {
        this.thermalCalculator.isEmptyVisibleTransmittance = true;
        isValid = false;
      }

    }
    return isValid;
  }
  //#endregion
  //#region calculate/cancel button operation
  calculate() {
    this.thermalCalculator.isSubmitted = true;
    if (!this.validateThermalCalculatorForm()) {
      this.thermalCalculator.isSelectionPanelValid = false;
      return;
    }
    this.thermalCalculator.isSelectionPanelValid = true;
    // this.saveInProcess = true;
    const controls = this.thermalCalculatorForm.controls;
    const body: IThermalCalculator = {
      //projectName: controls.projectName.value,
      //projectLocation: controls.projectLocation.value,
      productType: controls.productType.value ? controls.productType.value : "",
      productSeries: controls.productSeries.value ? controls.productSeries.value.productSeries : "",
      uFactor: controls.ufactor.value ? controls.ufactor.value.uFactor : "",
      solarHeatGainCoefficient: controls.solarHeat.value ? controls.solarHeat.value.solarHeatGainCoefficient : "",
      visibleTransmittance: controls.visibleTransmittance.value ? controls.visibleTransmittance.value.visibleTransmittance : "",
      sizeCategory: controls.sizeCategory.value ? controls.sizeCategory.value : false,
      visionValue: controls.visibleArea.value ? controls.visibleArea.value.toString() : "",
      horizontalDLO: this.thermalCalculatorResource.horizontalDlo,
      verticalDLO: this.thermalCalculatorResource.verticalDlo,
      totalHorizontals: this.thermalCalculatorResource.totalOfHorizontal,
      totalVerticals: this.thermalCalculatorResource.totalOfVertical,



    }
    this.selfService.thermalCalculateSubmit(body).subscribe(response => {
      this.thermalCalculator.isSubmitted = false;
      this.saveInProcess = false;
      this.showCalculationTable = true;
      this.showCalculationEntries = false;
      this.list = response; //assign calculation response here 
    })
  }
  cancel() {
    //do something
  }
  //#endregion
  //#region panel change
  continueToNextPanel() {
    console.log(this.f);
    console.log(this.thermalCalculatorResource);
    this.thermalCalculator.isSubmitted = true;
    if (!this.validateThermalCalculatorForm()) {
      this.thermalCalculator.isSelectionPanelValid = false;
      return;
    }
    this.thermalCalculator.isSelectionPanelValid = true;
    this.panel.childrenItems.forEach(item => {
      if (item.expanded) {
        item.expanded = false;
        item.selected = false;
      }
    });
    this.panel.childrenItems[1].expanded = true;
    this.panel.childrenItems[1].selected = true;

  }
  //#endregion
  //#region calculate table operations
  editSelection() {
    this.showCalculationTable = false;
    this.showCalculationEntries = true;
    //this.f.sizeCategory.setValue(null);
    //this.toggle(null);
    //load controls details here
  }
  loadingPDF: boolean;
   downloadThermalCalculator(list) {
    this.loadingPDF = true;
    var todaysDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    let docDefinition = {
      content: [
        {
          text: this.thermalCalculatorForm.controls.projectName.value + ' | ' + this.thermalCalculatorForm.controls.projectLocation.value,
          bold: true
        },
        {
          text: 'Date: ' + todaysDate,
          bold: true,
          margin: [0, 0, 0, 15]
        },
        {
          text: this.thermalCalculatorForm.controls.productType.value + ' | ' + this.thermalCalculatorForm.controls.productSeries.value.productSeries,
          margin: [0, 0, 0, 40]
        },
        {
          table: {
            headerRows: 1,
            widths: [120, 230, 120],
            //body: [
            //  [{ text: 'COG', bold: true }, { text: 'NFRC Size Values 78.75\" X 78.75\"', bold: true }, { text: 'Project values', bold: true }],
            //  ['U-Factor:' + this.thermalCalculatorForm.controls.ufactor.value.uFactor, 'U-Factor:' + this.thermalCalculatorForm.controls.ufactor.value.uFactor, 'U-Factor:' + this.thermalCalculatorForm.controls.ufactor.value.uFactor],
            //  ['SGHC:' + this.thermalCalculatorForm.controls.solarHeat.value.solarHeatGainCoefficient, 'SGHC:' + this.thermalCalculatorForm.controls.solarHeat.value.solarHeatGainCoefficient, 'SGHC:' + this.thermalCalculatorForm.controls.solarHeat.value.solarHeatGainCoefficient],
            //  ['VT:' + this.thermalCalculatorForm.controls.visibleTransmittance.value.visibleTransmittance, 'VT:' + this.thermalCalculatorForm.controls.visibleTransmittance.value.visibleTransmittance, 'VT:' + this.thermalCalculatorForm.controls.visibleTransmittance.value.visibleTransmittance],
            //]
            body: [
              [
                { text: (this.thermalCalculatorTxt.coglbl ? this.thermalCalculatorTxt.coglbl : this.thermalCalculator.coglbl), bold: true },
                { text: (this.thermalCalculatorTxt.ngrcLbl ? this.thermalCalculatorTxt.ngrcLbl : this.thermalCalculator.ngrcLbl) + ' ' + list.nfrcSizeValues, bold: true },
                { text: (this.thermalCalculatorTxt.projectValueLbl ? this.thermalCalculatorTxt.projectValueLbl : this.thermalCalculator.projectValueLbl), bold: true }],

              [
                (this.thermalCalculatorTxt.ufactorLbl ? this.thermalCalculatorTxt.ufactorLbl : this.thermalCalculator.ufactorLbl) + ' : ' + list.coguFactor,
                (this.thermalCalculatorTxt.ufactorLbl ? this.thermalCalculatorTxt.ufactorLbl : this.thermalCalculator.ufactorLbl) + ' : ' + list.nfrcuFactor,
                (this.thermalCalculatorTxt.ufactorLbl ? this.thermalCalculatorTxt.ufactorLbl : this.thermalCalculator.ufactorLbl) + ' : ' + list.projectValuesUFactor
              ],
              [
                (this.thermalCalculatorTxt.shgcLbl ? this.thermalCalculatorTxt.shgcLbl : this.thermalCalculator.shgcLbl )+ ' : ' + list.cogSolarHeatGainCoefficient,
                (this.thermalCalculatorTxt.shgcLbl ? this.thermalCalculatorTxt.shgcLbl : this.thermalCalculator.shgcLbl )+ ' : ' + list.nfrcSolarHeatGainCoefficient,
                (this.thermalCalculatorTxt.shgcLbl ? this.thermalCalculatorTxt.shgcLbl : this.thermalCalculator.shgcLbl )+ ' : ' + list.projectValuesSolarHeatGainCoefficient
              ],
              [
                (this.thermalCalculatorTxt.vtLbl ? this.thermalCalculatorTxt.vtLbl : this.thermalCalculator.vtLbl )+ ' : ' + list.cogVisibleTransmittance,
                (this.thermalCalculatorTxt.vtLbl ? this.thermalCalculatorTxt.vtLbl : this.thermalCalculator.vtLbl )+ ' : ' + list.nfrcVisibleTransmittance,
                (this.thermalCalculatorTxt.vtLbl ? this.thermalCalculatorTxt.vtLbl : this.thermalCalculator.vtLbl )+ ' : ' + list.projectValuesVisibleTransmittance
              ],
            ]
          }
        },
        { text: '', margin: [0, 20, 0, 8] },
        {
          table: {
            header: 0,
            widths: [120, 230, 120],
            body: [
              [
                (this.thermalCalculatorTxt.visionAreaLbl ? this.thermalCalculatorTxt.visionAreaLbl : this.thermalCalculator.visionAreaLbl) + ' :',
                (this.thermalCalculatorTxt.visionAreaLbl ? this.thermalCalculatorTxt.visionAreaLbl : this.thermalCalculator.visionAreaLbl) + ' : ' + list.nfrcVisionArea,
                (this.thermalCalculatorTxt.visionAreaLbl ? this.thermalCalculatorTxt.visionAreaLbl : this.thermalCalculator.visionAreaLbl) + ' : ' + list.projectValuesVisionArea
              ],
            ]
          }
        },
        { text: '', margin: [0, 20, 0, 8] },
        {
          table: {
            header: 0,
            body: [
              [
                (this.thermalCalculatorTxt.tableContent2Lbl ? this.thermalCalculatorTxt.tableContent2Lbl : this.thermalCalculator.tableContent2Lbl) + ' : ' + list.kawneerTestReportNFRC102
              ],
              [
                (this.thermalCalculatorTxt.tableContent3Lbl ? this.thermalCalculatorTxt.tableContent3Lbl : this.thermalCalculator.tableContent3Lbl) + ' : ' + list.kawneerTestReportAMMA
              ],
              [
                (this.thermalCalculatorTxt.tableContent4Lbl ? this.thermalCalculatorTxt.tableContent4Lbl : this.thermalCalculator.tableContent4Lbl) + ' : ' + list.kawneerTestReportNFRC
              ],
              [
                (this.thermalCalculatorTxt.tableContent5Lbl ? this.thermalCalculatorTxt.tableContent5Lbl : this.thermalCalculator.tableContent5Lbl) + ' : ' + list.complianceCertificate
              ],
            ]
          }
        }
        ,
        {
          text: this.thermalCalculatorTxt.termsConditionTitleLbl ? this.thermalCalculatorTxt.termsConditionTitleLbl : this.thermalCalculator.termsConditionTitleLbl,
          margin: [0, 180, 0, 8],
          alignment: 'center'
        },
        {
          table: {
            header: 0,
            body: [
              [
                this.thermalCalculatorTxt.termsConditionContentLbl ? this.thermalCalculatorTxt.termsConditionContentLbl : this.thermalCalculator.termsConditionContentLbl
              ],
            ],
          }
        }
      ],

    };
    pdfMake.createPdf(docDefinition).download('ThermalProperties.pdf');
    this.loadingPDF = false;
  }
  //#endregion

  receiveData($event) {
    this.thermalCalculatorResource = $event;
  }
}
